/**
 *  @hidden
 */
export const load = 'load';
/** @hidden */
export const rowDataBound = 'rowDataBound';
/** @hidden */
export const dataBound = 'dataBound';
/** @hidden */
export const queryCellInfo = 'queryCellInfo';
/** @hidden */
export const beforeDataBound = 'beforeDataBound';
/** @hidden */
export const actionBegin = 'actionBegin';
/** @hidden */
export const dataStateChange = 'dataStateChange';
/** @hidden */
export const actionComplete = 'actionComplete';
/** @hidden */
export const rowSelecting = 'rowSelecting';
/** @hidden */
export const rowSelected = 'rowSelected';
/** @hidden */
export const checkboxChange = 'checkboxChange';
/** @hidden */
export const rowDeselected = 'rowDeselected';
/** @hidden */
export const toolbarClick = 'toolbarClick';
/** @hidden */
export const beforeExcelExport = 'beforeExcelExport';
/** @hidden */
export const beforePdfExport = 'beforePdfExport';
/** @hidden */
export const resizeStop = 'resizeStop';
/** @hidden */
export const expanded = 'expanded';
/** @hidden */
export const expanding = 'expanding';
/** @hidden */
export const collapsed = 'collapsed';
/** @hidden */
export const collapsing = 'collapsing';
/** @hidden */
export const remoteExpand = 'remoteExpand';
/** @hidden */
export const localPagedExpandCollapse = 'localPagedExpandCollapse';
/** @hidden */
export const pagingActions = 'pagingActions';
/** @hidden */
export const printGridInit = 'printGrid-Init';
/** @hidden */
export const contextMenuOpen = 'contextMenuOpen';
/** @hidden */
export const contextMenuClick = 'contextMenuClick';
/** @hidden */
export const beforeCopy = 'beforeCopy';
/** @hidden */
export const beforePaste = 'beforePaste';
/** @hidden */
export const savePreviousRowPosition = 'savePreviousRowPosition';
/** @hidden */
export const crudAction = 'crudAction';
/** @hidden */
export const beginEdit = 'beginEdit';
/** @hidden */
export const beginAdd = 'beginAdd';
/** @hidden */
export const recordDoubleClick = 'recordDoubleClick';
/** @hidden */
export const cellSave = 'cellSave';
/** @hidden */
export const cellSaved = 'cellSaved';
/** @hidden */
export const cellEdit = 'cellEdit';
/** @hidden */
export const batchDelete = 'batchDelete';
/** @hidden */
export const batchCancel = 'batchCancel';
/** @hidden */
export const batchAdd = 'batchAdd';
/** @hidden */
export const beforeBatchDelete = 'beforeBatchDelete';
/** @hidden */
export const beforeBatchAdd = 'beforeBatchAdd';
/** @hidden */
export const beforeBatchSave = 'beforeBatchSave';
/** @hidden */
export const batchSave = 'batchSave';
/** @hidden */
export const keyPressed = 'key-pressed';
/** @hidden */
export const updateData = 'update-data';
/** @hidden */
export const doubleTap = 'double-tap';
/** @hidden */
export const virtualColumnIndex = 'virtualColumnIndex';
/** @hidden */
export const virtualActionArgs = 'virtual-action-args';
/** @hidden */
export const destroy = 'destroy';
/** @hidden */
export const dataListener = 'data-listener';
/** @hidden */
export const indexModifier = 'index-modifier';
/** @hidden */
export const beforeStartEdit = 'edit-form';
/** @hidden */
export const beforeBatchCancel = 'before-batch-cancel';
/** @hidden */
export const batchEditFormRendered = 'batcheditform-rendered';
/** @hidden */
export const detailDataBound = 'detailDataBound';
/** @hidden */
export const rowDrag = 'rowDrag';
/** @hidden */
export const rowDragStartHelper = 'rowDragStartHelper';
/** @hidden */
export const rowDrop = 'rowDrop';
/** @hidden */
export const rowDragStart = 'rowDragStart';
/** @hidden */
export const rowsAdd = 'rows-add';
/** @hidden */
export const rowsRemove = 'rows-remove';
/** @hidden */
export const rowdraging = 'row-draging';
/** @hidden */
export const rowDropped = 'row-dropped';
/** @hidden */
export const autoCol = 'auto-col';
/** @hidden */
export const rowDeselecting = 'rowDeselecting';
/** @hidden */
export const headerContent = 'e-headercontent';
/** @hidden */
export const movableContent = 'e-movablecontent';
/** @hidden */
export const movableHeader = 'e-movableheader';
/** @hidden */
export const frozenContent = 'e-frozencontent';
/** @hidden */
export const frozenHeader = 'e-frozenheader';
/** @hidden */
export const content = 'e-content';
/** @hidden */
export const table = 'e-table';
/** @hidden */
export const leftRight = 'Left-Right';
/** @hidden */
export const frozenRight = 'frozen-right';
/** @hidden */
export const frozenLeft = 'frozen-left';
/** @hidden */
export const ariaColIndex = 'aria-colindex';
/** @hidden */
export const ariaRowIndex = 'aria-rowindex';
/** @hidden */
export const actionFailure = 'actionFailure';
